import { Injectable } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { Logger } from '@core';
import { LANGUAGE_STORAGE_KEY, resolveSupportedLanguage } from '@jts-shared/i18n';
import enUS from '../../translations/en-US.json';
import frFR from '../../translations/fr-FR.json';

const log = new Logger('I18nService');

@Injectable({
  providedIn: 'root',
})
export class I18nService {
  defaultLanguage!: string;
  supportedLanguages!: string[];

  private langChangeSubscription!: Subscription;

  constructor(private translateService: TranslateService) {
    translateService.setTranslation('en-US', enUS);
    translateService.setTranslation('fr-FR', frFR);
  }

  init(defaultLanguage: string, supportedLanguages: string[]) {
    this.defaultLanguage = defaultLanguage;
    this.supportedLanguages = supportedLanguages;
    this.language = '';

    this.langChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, event.lang);
    });
  }

  destroy() {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

  set language(language: string) {
    const nextLanguage = resolveSupportedLanguage({
      browserLanguage: this.translateService.getBrowserCultureLang() || '',
      defaultLanguage: this.defaultLanguage,
      requestedLanguage: language,
      storedLanguage: localStorage.getItem(LANGUAGE_STORAGE_KEY),
      supportedLanguages: this.supportedLanguages,
    });

    log.debug(`Language set to ${nextLanguage}`);
    this.translateService.use(nextLanguage);
  }

  get language(): string {
    return this.translateService.currentLang;
  }
}
